import { render, staticRenderFns } from "./ResourceCardPagination.vue?vue&type=template&id=e33cc1d2"
import script from "./ResourceCardPagination.vue?vue&type=script&lang=ts"
export * from "./ResourceCardPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e33cc1d2')) {
      api.createRecord('e33cc1d2', component.options)
    } else {
      api.reload('e33cc1d2', component.options)
    }
    module.hot.accept("./ResourceCardPagination.vue?vue&type=template&id=e33cc1d2", function () {
      api.rerender('e33cc1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/ResourceCardPagination.vue"
export default component.exports